import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Pricelist from './Pricelist';
import authService from './api-authorization/AuthorizeService';

interface PriceListTowerItem {
    id: number;
    height: number;
    threeDayRate: number;
    sevenDayRate: number;
    additionalHireRateDay: number;
    installDismantleFee: number;
    isDirty: boolean;
}

const AdminPriceListTowerData = (props: RouteComponentProps<{}>) => {
    
    const [priceListTowerItems, setPriceListTowerItems] = React.useState<PriceListTowerItem[]>([]);
    
    //const [systemCompanyId, setSystemCompanyId] = React.useState(2);
    const [loading, setLoading] = React.useState(false);
    const [pricelistLoading, setPricelistLoading] = React.useState(false);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});


    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=AdminPricelistsView&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                getPricelist();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const getPricelist = async () => {
        const token = await authService.getAccessToken();
            
        axios.get('api/PriceList/GetPricelistTower', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var pricelist = res.data.towerItems;
            let newRow = addBlankRow();
            pricelist.push(newRow);
            setPriceListTowerItems(pricelist);
            setLoading(false);
            setPricelistLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
        
    }

    const addBlankRow = () => {
        let pricelistItem: PriceListTowerItem = {
            id: 0,
            height: 0,
            threeDayRate: 0,
            sevenDayRate: 0,
            additionalHireRateDay: 0,
            installDismantleFee: 0,
            isDirty: false
        };

        return pricelistItem;
    }

    const handleCellChange = (e: any, index: number) => {
        let towerItems = [...priceListTowerItems];
        let towerItem = towerItems[index];
        let value = e.target.value * 1;
        var updatedItem: any = {};
        updatedItem = towerItem;
        updatedItem[e.target.name] = value;
        updatedItem.isDirty = true;

        let lastRow = towerItems.length - 1;
        if (index == lastRow) {
            let newRow = addBlankRow();
            towerItems.push(newRow);
        }

        setPriceListTowerItems(towerItems);
    }

    const deleteItem = (e: any, index: number) => {

    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (priceListTowerItems.length === 1) {
            errorList["pricelistitems"] = "Please enter at least one item!";
            setErrors(errorList);
            return true;
        }

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < priceListTowerItems.length - 1; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (!priceListTowerItems[i].height || priceListTowerItems[i].height <= 0) {
                newErrorString += "Height, ";
                error = true;
            }
            if (!priceListTowerItems[i].threeDayRate || priceListTowerItems[i].threeDayRate <= 0) {
                newErrorString += "3 Day Rate, ";
                error = true;
            }
            if (!priceListTowerItems[i].sevenDayRate || priceListTowerItems[i].sevenDayRate <= 0) {
                newErrorString += "Weekly Rate, ";
                error = true;
            }
            if (!priceListTowerItems[i].additionalHireRateDay || priceListTowerItems[i].additionalHireRateDay <= 0) {
                newErrorString += "Additional Hire, ";
                error = true;
            }
            if (!priceListTowerItems[i].installDismantleFee || priceListTowerItems[i].installDismantleFee <= 0) {
                newErrorString += "Install / Dismantle Fee, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errorList["pricelistitems"] = errorString;
        }
        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            var changed = priceListTowerItems.filter(p => p.isDirty);

            if (changed.length === 0) {
                toast.info("No items have changed.");
            } else {
                savePricelist(changed);
            }
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    const savePricelist = async (changed: PriceListTowerItem[]) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var savePriceList = {
            towerItems: changed,
            subId: user.sub
        };

        axios.post('api/PriceList/SavePricelistTower', savePriceList, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Tower Price List Saved Successfully");
                setPricelistLoading(true);
                getPricelist();
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    
    let lastRow = priceListTowerItems.length - 1;
    const renderDetails = (
        <div>
            <div className={pricelistLoading ? "" : "hidden" }>Loading Tower Pricelist...</div>
            <div className={pricelistLoading ? "hidden" : "table__margin overflowAuto"}>
                <table className="table tableColours pricelist-width">
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th></th>
                            <th>Height</th>
                            <th>3 Day Rate</th>
                            <th>Weekly Rate</th>
                            <th>Additional Hire Rate</th>
                            <th>Install/Dismantle Fee</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {priceListTowerItems.map((item, index) =>
                            <tr key={index}>
                                <td className="hidden">{item.id}</td>
                                <td className="table__text--align">{index + 1}</td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.1" className='form-control textalignright' id="height" name="height" value={item.height} onChange={(e) => handleCellChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='form-control textalignright' id="threeDayRate" name="threeDayRate" value={item.threeDayRate} onChange={(e) => handleCellChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='form-control textalignright' id="sevenDayRate" name="sevenDayRate" value={item.sevenDayRate} onChange={(e) => handleCellChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='form-control textalignright' id="additionalHireRateDay" name="additionalHireRateDay" value={item.additionalHireRateDay} onChange={(e) => handleCellChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    <input type='number' min="0" step="0.01" className='form-control textalignright' id="installDismantleFee" name="installDismantleFee" value={item.installDismantleFee} onChange={(e) => handleCellChange(e, index)} />
                                </td>
                                <td className="table__text--align">
                                    {index != lastRow ?
                                        <div className="delete--tablecell">
                                            <a className="makeitred" href="#" onClick={(e) => deleteItem(e, index)}>
                                                <span className="fas fa-times-circle delete--icon alignIconCenter"></span>
                                            </a>
                                        </div> : ""
                                    }
                                </td>
                            </tr>

                        )}
                    </tbody>
                </table>
                {errors["pricelistitems"] ?
                    (errors["pricelistitems"]).split("\n").map((item: any, key: any) => {
                        return <span className="label errors" key={key}>{item}<br /></span>
                    })
                    : ""}
            </div>
            <div className={pricelistLoading ? "hidden" : "marginBottom10"}>
                <button className="defaultbutton defaultbutton__large" type="button" onClick={save}>Save</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Tower Price List</h1>
            {contents}
        </div>
    );


}

export default AdminPriceListTowerData;